import React from "react";
import { motion } from "framer-motion";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import MoujibLogo from "components/ui/logo";

const Footer = () => {
  const footerLinks = {
    Product: [
      { label: "Features", href: "/#" },
      { label: "Pricing", href: "/#" },
      { label: "How It Works", href: "/#" },
      { label: "Integrations", href: "/#" },
    ],
    Company: [
      { label: "About", href: "/about" },
      { label: "Blog", href: "/#" },
      { label: "Careers", href: "/#" },
      { label: "Press Kit", href: "/#" },
    ],
    Legal: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Cookie Policy", href: "/#" },
      { label: "GDPR", href: "/#" },
    ],
    Support: [
      { label: "Help Center", href: "/#" },
      { label: "Documentation", href: "/#" },
      { label: "API Reference", href: "/#" },
      { label: "Contact", href: "/#" },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: "#", label: "Facebook" },
    { icon: Twitter, href: "#", label: "Twitter" },
    { icon: Linkedin, href: "#", label: "LinkedIn" },
    { icon: Instagram, href: "#", label: "Instagram" },
  ];

  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-6 py-16">
        {/* Top divider with glow */}
        <div className="h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent mb-12" />

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <MoujibLogo className="mb-6" size="xxxl" variant="light" />

              {/* Social Icons */}
              <div className="flex gap-3">
                {socialLinks.map((social, index) => {
                  const Icon = social.icon;
                  return (
                    <motion.a
                      key={index}
                      href={social.href}
                      aria-label={social.label}
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-10 h-10 rounded-full bg-secondary border border-border flex items-center justify-center hover:border-primary hover:bg-primary/5 transition-all duration-300"
                    >
                      <Icon className="w-5 h-5 text-muted-foreground hover:text-primary transition-colors" />
                    </motion.a>
                  );
                })}
              </div>
            </motion.div>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(
            ([category, links], categoryIndex) => (
              <motion.div
                key={category}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: categoryIndex * 0.1, duration: 0.5 }}
                viewport={{ once: true }}
              >
                <h4 className="font-heading font-semibold mb-4">{category}</h4>
                <ul className="space-y-3">
                  {links.map(({ label, href }, linkIndex) => (
                    <li key={linkIndex}>
                      <a
                        href={href}
                        className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
                      >
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              </motion.div>
            )
          )}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
              <p className="text-muted-foreground text-sm">
                © 2025 PRODSOLLUTIONS. All rights reserved.
              </p>
              <a
                href="tel:+14844760107"
                className="text-primary hover:text-primary/80 text-sm font-medium transition-colors"
              >
                +1 (484) 476-0107
              </a>
            </div>
            <div className="flex gap-6">
              <a
                href="/privacy"
                className="text-muted-foreground hover:text-primary text-sm transition-colors"
              >
                Privacy
              </a>
              <a
                href="/terms"
                className="text-muted-foreground hover:text-primary text-sm transition-colors"
              >
                Terms
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-primary text-sm transition-colors"
              >
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
